/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weight: NonNullable<unknown>, reps: NonNullable<unknown> }} Workout_Values_WeightedInputs */

const en_workout_values_weighted = /** @type {(inputs: Workout_Values_WeightedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weight} kg × ${i?.reps}`)
};

const pl_workout_values_weighted = /** @type {(inputs: Workout_Values_WeightedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.weight} kg × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "{weight} kg × {reps}" |
*
* @param {Workout_Values_WeightedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const workout_values_weighted = /** @type {((inputs: Workout_Values_WeightedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Values_WeightedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_workout_values_weighted(inputs)
	return en_workout_values_weighted(inputs)
});